import React, { useEffect } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'
import { render } from 'enzyme';

const RecipeDetailLayout = (props) => (
  <div>
        <Placeholder name="main-layout" rendering={props.rendering} itemid={props.itemidkey}/>
  </div>
);

export default RecipeDetailLayout;
